import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Scheduling/hooks/useSchedulingAssignment.ts
var DEFAULT_CACHE_STRATEGY = "cache-only";
function useSchedulingAssignment(id, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetSchedulingAssignment.v1, id ? { id } : void 0, {
		cacheStrategy: opts.cacheStrategy || DEFAULT_CACHE_STRATEGY,
		fire: !!id && fire
	});
	return {
		data: data?.schedulingAssignment,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useSchedulingAssignment };

//# sourceMappingURL=useSchedulingAssignment.js.map